module.exports = __webpack_public_path__ + "img/forward_white.4d6166a2.svg";